'use strict';

/**
 * Пользовательские праздники
 */
(function () {
    var self = Fotobook.holidays.user = {
        EVENT_USER_HOLIDAYS_CHANGED: 'EVENT_USER_HOLIDAYS_CHANGED',
        datesFilter: undefined,

        getFilter() {
            if (!self.datesFilter) {
                self.datesFilter = new Fotobook.HolidaysFilter();
            }
            return self.datesFilter;
        },
        getDate(date) {
            return self.getFilter().getDate(date);
        },
        setDates(holidays) {
            this.getFilter().setDates(holidays || {});
            $(document).triggerHandler(this.EVENT_USER_HOLIDAYS_CHANGED);
        },
        getDates() {
            return this.getFilter().getDates();
        },
    };
})();
